/**
 * 用户数据
 */
export class User {
  /**
   * 账号
   */
  account
  /**
   * 账号id
   */
  accountId
  /**
   * 企业id
   */
  companyId
  /**
   * 企业名称
   */
  companyName
  /**
   * 企业认证状态 0：未认证；1：管理员资料已提交；2：企业基本资料(没有申请表)已提交；3：已提交待审核；
   * 4：审核通过；5：审核不通过；6：人工初审通过
   */
  companyStatus

  /**
   * 企业认证类型
   * 0：银行卡认证
   * 1：纸质审核认证
   * 2：法人身份认证
   * 3：电子营业执照
   * 4：法人授权认证
   */
  companyVerifyType
  /**
   * 邮箱
   */
  email
  /**
   * 是否设置邮箱
   */
  haveEmail
  /**
   * 是否设置密码
   */
  havePassword
  /**
   * 身份证号码
   */
  idCard
  /**
   * 是否是个人用户
   */
  isPerson
  logo
  /**
   * 手机号码
   */
  mobile
  /**
   * 姓名
   */
  name
  /**
   * 个人实名状态 2 审核通过 -1 未注册 0 未认证 1 已提交待审核 3 审核不通过
   */
  status
  /**
   * 用户权限
   */
  userMenu
  /**
   * 姓名（无星号）
   */
  realName
  /**
   * 是否超级管理员 true：是 false：否
   */
  superAdminFlg
  /**
   * 是否拥有套餐
   */
  hasProduct
  /**
   * 是否拥有印章
   */
  hasSign
  /**
   * 证件类型 0 身份证 1 护照 B 港澳居民来往内地通行证 C 台湾居民来往内地通行证
   */
  certType
  /**
   * 企业简称
   */
  shortName
  /**
   * 是否为3.0迁移数据
   */
  isMigration
  /**
   * 0：迁移失败 1：迁移成功 2：待补充实名 3：实名信息不合规
   */
  migrationStatus

  /**
   * 是否显示 3.0 历史合同
   */
  isShowHistory
  fddSuperAdminName
  isFddSuperAdmin
  upgradeFlag

  constructor(user) {
    const {
      account,
      accountId,
      companyId,
      companyName,
      companyStatus,
      email,
      haveEmail,
      havePassword,
      idCard,
      isPerson,
      logo,
      mobile,
      name,
      status,
      userMenu,
      realName,
      superAdminFlg,
      hasProduct,
      hasSign,
      certType,
      shortName,
      isMigration,
      migrationStatus,
      isShowHistory,
      companyVerifyType,
      fddSuperAdminName,
      upgradeFlag,
      isFddSuperAdmin
    } = user

    Object.assign(this, user, {
      account,
      accountId,
      companyId,
      companyName,
      companyStatus,
      email,
      haveEmail,
      havePassword,
      idCard,
      isPerson: isPerson || false,
      logo,
      mobile,
      name,
      status,
      userMenu,
      realName,
      superAdminFlg,
      hasProduct,
      hasSign,
      certType: certType || '0',
      shortName: shortName || '',
      isMigration: isMigration || false,
      migrationStatus: migrationStatus || 0,
      isShowHistory,
      companyVerifyType,
      fddSuperAdminName,
      upgradeFlag,
      isFddSuperAdmin
    })
  }
}
